import $ from "jquery";
import util, {getComponentFromPageBar, isCornerEdge, getSvgPath} from "../util";
import store from "../store";
import constants from "../constants";
import MenuObject from "./menu-object";
import { convertFramePosToPx, alignFramePreview, adjustAfterFrameResize } from "./reposition-frame";
import { ensureFrameDimensions } from "./dimension";
import Text from "./text";
import Matrix from "./matrix";
import { fixComponentLineHeight, setLineHeights } from "./line-height";
import History from "./history";
import {changeCircleSize, changeLineSize, changeSquareSize} from "./shape";
import {removeResizeSnapGuides} from "./snap-guides";
import {getRotationDegrees} from "./alignment";
import {updatePageBars} from "./selection";
import { isElementOffPage } from "./component";
import Cleaner from "./cleaner";
import * as actions from '../actions';
import * as component from './component';
import {getDraggedEdge} from "./index";

const EDGE_CLASS = {
    'top-left': '.top-left',
    'top': '.res-top',
    'top-right': '.top-right',
    'right': '.res-right',
    'bottom-right': '.btm-right',
    'bottom': '.res-btm',
    'bottom-left': '.btm-left',
    'left': '.res-left'
}

function onShapeResize($target, width, height) {
    const dims = util.getActiveDimensions();
    const widthCfg = {};
    widthCfg[dims.unit] = (dims.unit === 'px' ? width : util.pixelToInch(width));
    const heightCfg = {};
    heightCfg[dims.unit] = (dims.unit === 'px' ? height : util.pixelToInch(height));
    if (util.isLine($target)) changeLineSize($target, widthCfg, heightCfg);
    else if (util.isSquare($target)) changeSquareSize($target, widthCfg, heightCfg);
    else if (util.isCircle($target)) changeCircleSize($target, widthCfg, heightCfg);
}

function isMultiEdgeResize($target, edges) {
    let count = 0;
    if (edges.left) count++;
    if (edges.right) count++;
    if (edges.top) count++;
    if (edges.bottom) count++;
    return count > 1;
}

export function updateElementPercentDimension($element, width, height) {
    const pageWidth = util.getActiveDimensions().width;
    const pageHeight = util.getActiveDimensions().height;

    function update(width, height) {
        const percentWidth = util.pixelToPercent(width, pageWidth);

        $element.css('width', `${percentWidth}%`);
        if (!util.isResizable($element)) {
            const percentHeight = util.pixelToPercent(height, pageHeight);
            $element.css('height', `${percentHeight}%`);
        }
    }

    update(width, height);
}

export function onComponentResizeStart(event, reposition=false) {
    let $target = getComponentFromPageBar($(event.target));

    const left = $target.css('left');
    const top = $target.css('top');

    $target.attr('data-x', parseFloat(left));
    $target.attr('data-y', parseFloat(top));

    $target.attr('data-original-left', parseFloat(left));
    $target.attr('data-original-top', parseFloat(top));
    if (reposition) {
        let frame = null;
        $target.parent().find('[data-component="frame"').each(function () {
            if ($(this).attr('id') === $target.attr('id')) {
                frame = $(this);
            }
        })
        frame.attr('data-original-bg-css', frame.find('.img').css('background'));
    }

    if ($target.attr('data-component') === "frame") {
        $target.attr('data-original-bg-css', $target.find('.img').css('background'));
    }

    const width = $target.width();
    const height = $target.height();

    $target.attr('data-original-width', width);
    $target.attr('data-original-height', height);

    if (util.isResizable($target)) {
        $target.attr('data-original-rect-width', event.rect.width);
        $target.attr('data-original-rect-height', event.rect.height);
    }

    if (util.isShape($target)) {
        const $path = getSvgPath($target);
        if (!$path.attr('data-original-stroke-width')) {
            $path.attr('data-original-stroke-width', $path.attr('stroke-width'));
        }
    }

    setMouseCursor(event);
    hideOtherHandles(event);
}

function showAllHandles() {
    Object.keys(EDGE_CLASS).forEach(k => {
        $('.bars').find(EDGE_CLASS[k]).show();
    });
}

function hideOtherHandles(event) {
    const draggedEdge = getDraggedEdge(event.edges);
    Object.keys(EDGE_CLASS).forEach(k => {
       if (draggedEdge !== k) {
           $('.bars').find(EDGE_CLASS[k]).hide();
       }
    });
}

function setMouseCursor(event, end) {
    const draggedEdge = getDraggedEdge(event.edges);
    if (!end) {
        let cursor = '';
        if (draggedEdge === 'top-left' || draggedEdge === 'bottom-right') {
            cursor = 'nwse-resize';
        }
        if (draggedEdge === 'top-right' || draggedEdge === 'bottom-left') {
            cursor = 'nesw-resize';
        }
        if (draggedEdge === 'left' || draggedEdge === 'right') {
            cursor = 'ew-resize';
        }

        document.body.style.cursor = cursor;
    } else {
        document.body.style.cursor = '';
    }
}

export function onComponentMOResize(event, edge, $target) {
    const isCorner = isCornerEdge(edge);
    const fromOutside = $(event.target).hasClass('bars');
    const zoom = store.getState().zoom / 100;
    let rotation = getRotationDegrees($target);
    rotation = rotation * (Math.PI / 180);

    if (!isCorner) {
        let left = (parseFloat($target.attr('data-x')) || 0);

        if (constants.SCALED_ZOOM_APPROACH) {
            MenuObject.adaptEventToZoom(event, rotation, zoom);
        }

        let ogWidth = $target.width();
        let width = ogWidth + event.deltaRect.width;

        let leftShift = -event.deltaRect.left;
        if (event.edges.left) {
            leftShift += event.deltaRect.width / 2 - Math.cos(rotation) * event.deltaRect.width / 2;
        } else if (event.edges.right) {
            leftShift -= event.deltaRect.width / 2 - Math.cos(rotation) * event.deltaRect.width / 2;
        }

        if (width <= 15) {
            width = 15;
        }

        left += leftShift;
        $target.css({
            'left': `${left}px`,
            'width': `${width}px`,
        });
        $target.attr('data-x', left);

        MenuObject.ensureKidsHeight($target);

        if (constants.APPLY_LINE_HEIGHT_PATCH) {
            if (MenuObject.isMenuObject($target)) {
                MenuObject.fixDots($target);
                MenuObject.fixLineHeights($target, true);
            }
            if (util.isText($target)) {
                fixComponentLineHeight($target);
                Text.ensureTextSize($target);
            }
        }
    } else {
        let x = $target.css('left').replace('px', '');
        let y = $target.css('top').replace('px', '');

        x = ((parseFloat(x) || 0) + (event.deltaRect.left / zoom))
        y = ((parseFloat(y) || 0) + (event.deltaRect.top / zoom))

        if (constants.SCALED_ZOOM_APPROACH) {
            MenuObject.adaptEventToZoom(event, rotation, zoom);
        }

        const scale = getScale($target, event);

        const width = event.rect.width / zoom;
        const height = event.rect.height / zoom;
        const threshold = MenuObject.isMenuObject($target) ? 50 : 15;

        if ((event.rect.width <= threshold || event.rect.height <= threshold) && event.deltaRect.height <= 0) {
            return;
        }

        if (fromOutside) {
            $target.css({
                width: `${width}px`,
                height: `${height}px`,
            });
        }

        Object.assign(event.target.style, {
            width: `${width}px`,
            height: `${height}px`,
        })
        Object.assign(event.target.dataset, {x, y})

        const $kid = $target.find('.wrapper, .ql-container');
        $kid.css({
            'transform': `scale(${scale}) translate(0px, 0px)`,
            'transform-origin': '0px 0px'
        });

        $target.css({
            left: `${x}px`,
            top: `${y}px`,
        });

        MenuObject.ensureKidsHeight($target, scale, $kid);
    }
    updatePageBars($target);
}

export function onComponentResize(event, edge, reposition = false) {
    let $target = getComponentFromPageBar($(event.target));
    const isMenuObject = MenuObject.isMenuObject($target);

    if (util.isResizable($target)) {
        return onComponentMOResize(event, edge, $target);
    } else {
        let left = (parseFloat($target.attr('data-x')) || 0);
        let top = (parseFloat($target.attr('data-y')) || 0);

        // const snapped = showResizeSnapGuides($target, event, top, left, edge);

        let $frame = null;
        if (reposition) {
            $target.parent().find('[data-component="frame"').each(function () {
                if ($(this).attr('id') === $target.attr('id')) {
                    $frame = $(this);
                }
            })
        }

        const isImage = util.isImage($target);
        const isVideoFrame = util.isVideoFrame($target);
        const isFrame = util.isFrame($target);
        const isShape = util.isShape($target);
        const isIllustration = util.isIllustration($target);
        const isText = util.isText($target);
        const isSideResize = util.isSideResize(event);

        // if (util.isGroup($target)) {
        //     $target.find('*[data-component="text"]').css({'width': ''});
        // }

        const zoom = store.getState().zoom / 100;
        let rotation = getRotationDegrees($target);
        rotation = rotation * (Math.PI / 180);
        if (constants.SCALED_ZOOM_APPROACH) {
            MenuObject.adaptEventToZoom(event, rotation, zoom);
        }

        let ogWidth = $target.width();
        let ogHeight = $target.outerHeight();
        let width = ogWidth + event.deltaRect.width;
        let height = ogHeight + event.deltaRect.height;

        let ratio = MenuObject.getRatio($target);

        if ($target.attr('data-preserve-ratio') === 'false' && !reposition) {
            ratio = -1;
        }

        if (ratio > -1 && !isSideResize) {
            height = width / ratio;

            if (width <= 15) {
                width = 15;
                height = width / ratio;
            }

            if (height <= 15) {
                height = 15;
                width = height * ratio;
            }
        } else {
            if (width <= 15) width = 15;
            if (height <= 15) height = 15;
        }

        if (isShape) {
            onShapeResize($target, width, height);
        }

        if (isText) {
            setLineHeights($target);
        }

        if ((isFrame || isImage || isVideoFrame || isShape || isIllustration) && !isMultiEdgeResize($target, event.edges) && $target.attr('data-component') !== 'frame-preview') {
            $target.attr('data-custom-ratio', width / height);
        }

        function xshift() {
            let leftShift = -event.deltaRect.left;
            let topShift = 0;
            if (event.edges.left) {
                topShift -= Math.sin(rotation) * event.deltaRect.width / 2;
                leftShift += event.deltaRect.width / 2 - Math.cos(rotation) * event.deltaRect.width / 2;
            } else if (event.edges.right) {
                topShift += Math.sin(rotation) * event.deltaRect.width / 2;
                leftShift -= event.deltaRect.width / 2 - Math.cos(rotation) * event.deltaRect.width / 2;
            }

            return [leftShift, topShift];
        }

        function yshift() {
            let topShift = -event.deltaRect.top;
            let leftShift = 0;
            if (event.edges.top) {
                topShift += event.deltaRect.height / 2 - Math.cos(rotation) * event.deltaRect.height / 2;
                leftShift += Math.sin(rotation) * event.deltaRect.height / 2;
            } else if (event.edges.bottom) {
                topShift -= event.deltaRect.height / 2 - Math.cos(rotation) * event.deltaRect.height / 2;
                leftShift -= Math.sin(rotation) * event.deltaRect.height / 2;
            }

            return [leftShift, topShift];
        }

        let shiftX = [0, 0];
        let shiftY = [0, 0];

        if (!(ratio > -1 && !isSideResize) && !reposition) {
            if (width > 15) {
                shiftX = xshift();
            }
            if (height > 15) {
                shiftY = yshift();
            }
            left += shiftX[0] + shiftY[0];
            top += shiftX[1] + shiftY[1];
        } else if (width > 15 && height > 15) {
            if (event.edges.top) {
                event.deltaRect.top = event.deltaRect.left !== 0 ? event.deltaRect.left / ratio : event.deltaRect.right / ratio;
            }
            event.deltaRect.height = event.deltaRect.width / ratio;
            shiftX = xshift();
            shiftY = yshift();
            if (reposition) {
                const $frameImg = $frame.find('.img');
                const borderWidth = parseFloat($frame.find('.img').attr('data-border-width')) || 0;
                const dimensions = $frame.css('background-size').split(' ');
                const oldWidth = parseFloat(dimensions[0]);
                const oldHeight = parseFloat(dimensions[1]);

                let originalX = $frameImg.css('background-position-x');
                let originalY = $frameImg.css('background-position-y');
                if (originalX === '50%' || originalY === '50%') {
                    const converted = convertFramePosToPx($target, $frameImg);
                    originalX = converted[0];
                    originalY = converted[1];
                }

                const flippedX = $target.find('img').attr('flipped-x') === "true";
                const flippedY = $target.find('img').attr('flipped-y') === "true";
                originalX = parseFloat(originalX);
                originalY = parseFloat(originalY);
                let newX = flippedX ? originalX - event.deltaRect.right :
                    originalX - event.deltaRect.left;
                let newY = flippedY && event.edges.bottom ? originalY - event.deltaRect.height :
                    flippedY && event.edges.top ? originalY :
                        originalY - event.deltaRect.top;

                const frameWidth = $frame.width();
                const frameHeight = $frame.height();
                const hitLeft = event.edges.left && newX > 0 || flippedX && event.edges.left && Math.floor(width + 2*borderWidth + newX - frameWidth) < 0;
                const hitRight = event.edges.right && newX < Math.floor($frame.width() - width - 2*borderWidth) || flippedX && event.edges.right && newX > 0;
                const hitTop = event.edges.top && newY > 0 || flippedY && event.edges.top && Math.floor(height + 2*borderWidth + newY - frameHeight) < 0;
                const hitBot = event.edges.bottom && newY < Math.floor($frame.height() - height - 2*borderWidth) || flippedY && event.edges.bottom && newY > 0;
                if (hitLeft || hitRight || hitTop || hitBot) {
                    newX = originalX;
                    newY = originalY;
                    width = oldWidth;
                    height = oldHeight;
                }

                $frameImg.css('background-position-x', newX + 'px');
                $frameImg.css('background-position-y', newY + 'px');
                $frameImg.css('background-size', `${width}px ${height}px`);
            } else {
                left += shiftX[0] + shiftY[0];
                top += shiftX[1] + shiftY[1];
            }
        }

        if (isFrame && $target.attr('data-component') !== 'frame-preview') {
            let edges = { top: event.edges.top, bottom: event.edges.bottom, left: event.edges.left, right: event.edges.right };
            adjustAfterFrameResize(edges, $target, width, height, ratio, isSideResize);
        }

        if (reposition) {
            alignFramePreview($target, $frame);
        } else {
            $target.css('width', `${width}px`);
            $target.css('height', `${height}px`);
            $target.find('.txt').removeAttr('contenteditable');

            $target.css('left', `${left}px`);
            $target.css('top', `${top}px`);
        }

        $target.attr('data-x', left);
        $target.attr('data-y', top);

        if (constants.APPLY_LINE_HEIGHT_PATCH) {
            if (isMenuObject) {
                MenuObject.fixDots($target);
                MenuObject.fixLineHeights($target, true);
            }
        }

        if (util.isGroup($target)) {
            $target.find('*[data-component]').each(function() {
               const $groupChild = $(this);
               if (MenuObject.isMenuObject($groupChild)) {
                   MenuObject.ensureKidsHeight($groupChild);
                   MenuObject.fixDots($target);
                   MenuObject.fixLineHeights($groupChild, true);
               }
                if (util.isText($groupChild)) {
                    fixComponentLineHeight($groupChild);
                    Text.ensureTextSize($groupChild);
                }
            });
        }

        updatePageBars($target);
        hideOtherHandles(event);
    }
}

function onComponentMOResizeEnd(event, $target) {
    const oldWidth = $target.attr('data-original-width');
    const oldHeight = $target.attr('data-original-height');
    const oldScale = $target.attr('data-scale') || 1;
    const oldLeft = $target.attr('data-original-left');
    const oldTop = $target.attr('data-original-top');

    const newScale = component.getScale($target);
    const newWidth = $target.css('width').replace('px', '');
    const newHeight = $target.css('height').replace('px', '');
    const newTop = $target.css('top').replace('px', '');
    const newLeft = $target.css('left').replace('px', '');

    $target.attr('data-scale', newScale);

    const setFinalSize = (scale, width, height, top, left) => {
        const $kid = $target.find('.wrapper, .ql-container');
        $target.attr('data-scale', scale);

        $target.css({
            'width': `${width}px`,
            'height': `${height}px`,
            'top': `${top}px`,
            'left': `${left}px`,
        });
        $kid.css({
            'transform': `scale(${scale})`
        });

        MenuObject.ensureKidsHeight($target);

        let w = width;
        let h = height;
        $target.attr('data-inch-width', util.pixelToInch(w));
        $target.attr('data-inch-height', util.pixelToInch(h));

        $target.attr('data-px-width', Math.round(w / util.getActiveDimensions().onePixelRatio));
        $target.attr('data-px-height', Math.round(h / util.getActiveDimensions().onePixelRatio));

        if (constants.APPLY_LINE_HEIGHT_PATCH) {
            if (MenuObject.isMenuObject($target)) {
                MenuObject.fixDots($target);

                MenuObject.fixLineHeights($target, true);
            }
            if (util.isText($target)) {
                fixComponentLineHeight($target);
                Text.ensureTextSize($target);
            }
        }
        updatePageBars($target);
    }

    const redo = () => { setFinalSize(newScale, newWidth, newHeight, newTop, newLeft) };
    const undo = () => { setFinalSize(oldScale, oldWidth, oldHeight, oldTop, oldLeft) };

    redo();
    History.push(undo, redo, 'Resize');
}

export function onComponentResizeEnd(event, reposition = false) {
    let $target = getComponentFromPageBar($(event.target))

    setMouseCursor(event, true);

    if (util.isResizable($target)) {
        return onComponentMOResizeEnd(event, $target);
    } else {
        $target.find('.size-guide').remove();
        let repositionedFrame = null;
        if (reposition) {
            $target.parent().find('[data-component="frame"').each(function () {
                if ($(this).attr('id') === $target.attr('id')) {
                    repositionedFrame = $(this);
                }
            })
        }
        const setFinalSize = (width, height, top, left, bgCss) => {
            $target.css('top', top);
            $target.css('left', left);

            updateElementPercentDimension($target, width, height);

            if (util.isGroup($target)) {
                $target.find('.frame').each(function () {
                    const $frame = $(this);
                    if (util.isFrame($frame)) {
                        ensureFrameDimensions($frame, height);
                    }
                })
            }

            $target.attr('data-inch-width', util.pixelToInch(width));
            $target.attr('data-inch-height', util.pixelToInch(height));

            $target.attr('data-px-width', Math.round(width / util.getActiveDimensions().onePixelRatio));
            $target.attr('data-px-height', Math.round(height / util.getActiveDimensions().onePixelRatio));

            if ((util.isFrame($target) || util.isImage($target) || util.isVideoFrame($target) || util.isShape($target) || util.isIllustration($target)) && $target.attr('data-component') !== 'frame-preview') {
                $target.attr('data-custom-ratio', width / height);
            } else if (util.isText($target)) {
                Text.restartQuill($target);
            }

        // const pixelTop = typeof top === 'string' ? util.percentToPixel(parseFloat(top.split('%')[0]), util.getActiveDimensions().height) : top;
        // const pixelLeft = typeof left === 'string' ? util.percentToPixel(parseFloat(left.split('%')[0]), util.getActiveDimensions().width) : left;
        // const pixelWidth = typeof width === 'string' ? util.percentToPixel(parseFloat(width.split('%')[0]), util.getActiveDimensions().width) : width;
        // const pixelHeight = typeof height === 'string' ? util.percentToPixel(parseFloat(height.split('%')[0]), util.getActiveDimensions().height) : height;
        // Matrix.update($target.attr('id'), {top: pixelTop, left: pixelLeft, width: pixelWidth, height: pixelHeight});
        Matrix.update($target.attr('id'), { top, left, width, height });
        removeResizeSnapGuides();
        if (!MenuObject.isMenuObject($target)) {
            fixComponentLineHeight($target);
            if (util.isGroup($target)) {
                $target.find('.menu-object').each((index, element) => {
                    if (constants.APPLY_LINE_HEIGHT_PATCH) {
                        MenuObject.fixLineHeights($(element), true);
                    } else {
                        MenuObject.resetLineHeightsStandalone();
                    }
                })
            }
        } else {
            MenuObject.setHeights($target);
            if (constants.APPLY_LINE_HEIGHT_PATCH) {
                MenuObject.fixLineHeights($target, true);
            } else {
                MenuObject.resetLineHeightsStandalone();
            }
        }

            if (util.isShape($target)) {
                onShapeResize($target, width, height);
            }

            if (isElementOffPage($target)) {
                Cleaner.removeElement($target);
                store.dispatch(actions.deselect());
                return;
            }

            if (reposition) {
                repositionedFrame.find('.img').css('background', bgCss);
                alignFramePreview($target, repositionedFrame);
            }

            if ($target.attr('data-component') === "frame") {
                $target.find('.img').css('background', bgCss);
            }

            updatePageBars($target);
            showAllHandles();
        };

        const width = $target.width();
        const height = $target.height();
        const originalWidth = $target.attr('data-original-width');
        const originalHeight = $target.attr('data-original-height');
        let bgCss = null;
        let originalBgCss = null;

        if (reposition) {
            bgCss = repositionedFrame.find('.img').css('background');
            originalBgCss = repositionedFrame.attr('data-original-bg-css');
        }
        if ($target.attr('data-component') === "frame") {
            bgCss = $target.find('.img').css('background');
            originalBgCss = $target.attr('data-original-bg-css');
        }

        let top = $target[0].style.top.includes('%') ? $target[0].style.top : `${util.pixelToPercent(parseFloat($target[0].style.top), util.getActiveDimensions().height)}%`;
        const left = $target[0].style.left.includes('%') ? $target[0].style.left : `${util.pixelToPercent(parseFloat($target[0].style.left), util.getActiveDimensions().width)}%`;

        if ($target.position().top + height < 0) top = '0%';

        const originalTop = `${util.pixelToPercent(parseFloat($target.attr('data-original-top') || 0), util.getActiveDimensions().height)}%`;
        const originalLeft = `${util.pixelToPercent(parseFloat($target.attr('data-original-left') || 0), util.getActiveDimensions().width)}%`;

        const redo = () => {
            setFinalSize(width, height, top, left, bgCss);
        };

        const undo = () => {
            setFinalSize(originalWidth, originalHeight, originalTop, originalLeft, originalBgCss);
        };

        redo();
        History.push(undo, redo, 'Resize');
    }
}

export function getScale($target, event, addDelta) {
    const oldWidth = $target.attr('data-original-rect-width');
    const oldHeight = $target.attr('data-original-rect-height');
    const newWidth =  event.rect.width;
    const newHeight = event.rect.height;

    const oldArea = oldWidth * oldHeight;
    const newArea = newWidth * newHeight;

    const z = Math.sqrt(newArea / oldArea);
    const x = $target.attr('data-scale') || 1;

    return x * z;
}

export function rotateCursor(event) {
    let $target = $(event.target);
    $target = getComponentFromPageBar($target);

    let rotation = getRotationDegrees($target.parent().parent());
    if ($target.hasClass('top-right')) {
        rotation = rotation
    } else if ($target.hasClass('res-right')) {
        rotation += 45;
    } else if ($target.hasClass('btm-right')) {
        rotation += 90;
    } else if ($target.hasClass('res-btm')) {
        rotation += 135;
    } else if ($target.hasClass('btm-left')) {
        rotation += 180;
    } else if ($target.hasClass('res-left')) {
        rotation += 225;
    } else if ($target.hasClass('top-left')) {
        rotation += 270;
    } else if ($target.hasClass('res-top')) {
        rotation += 315;
    }
    rotation = rotation % 365;
    let cursorString = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 20 20'%3e%3cg transform='rotate(${rotation} 9 9)'%3e%3cpath fill='white' d='M11.7 9.1l-4 4.1 2.8 2.8H2V7.5l2.9 2.8 4-4 1.4-1.4L7.5 2H16v8.5l-2.8-2.8z'/%3e%3cpath d='M10.7 8.7l-4.4 4.5L8.1 15H3V9.9l1.9 1.9 4.4-4.5 2.5-2.4L9.9 3H15v5.1l-1.8-1.8z'/%3e%3c/g%3e%3c/svg%3e") 8 8, pointer`;
    let handles = document.getElementsByClassName('drag-res');
    for (let i = 0; i < handles.length; i++) {
        handles[i].style.cursor = '';
        handles[i].style.cursor = cursorString;
    }
}
